import React from 'react'
import { axiosWithKey } from "~/axios"
import { userLanguageSelector } from '~/tools/localization'
import StripeCCForm from '../CreateSubscription/Billing/StripeCCForm'
import AcceptedPayments from '../CreateSubscription/AcceptedPayments'
import popup from '../../popup'
import { getToken } from '~/redux/user/tokens'
import Spinner from '~/components/Spinner'
import { updateUserCard } from '~/redux/user/helpers'
import { getBillingToken } from '~/tools/stripe';
import './style.css'

class View extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      metaDataMap: {},
      loading: true
    }
  }
  componentDidMount() {
    this.fetchPageData()
  }

  fetchPageData = () => {
    const { internalName } = window.settings;
      getToken(token => {
        return axiosWithKey({
          method: "GET",
          url: `/content/pages?site=${internalName}&path=/subscribe&languageCode=${userLanguageSelector()}&includeContent=true`,
          headers: { Authorization: token }
        })
          .then(res => {
            const response = res.data.modules[0].metadataMap
            this.setState({metaDataMap: response, loading: false})
          })
          .catch();
      });
  }

  render() {
    if (this.state.loading)
      return (<div className="loading centered"><Spinner/></div>)
    const metaDataMap = this.state.metaDataMap
    return (
      <div className="update-stripe-payment centered opaque padded">
        <h2>{metaDataMap.updateBillingHeader}</h2>
        <AcceptedPayments field={metaDataMap.weAccept}/>
        <StripeCCForm
          submitCaption={metaDataMap.updateBilling}
          apiKey={ ((window.settings.paymentProviders || {}).stripe || {}).apiKey }
          onToken={ (token, stripeObj) => {
            return getBillingToken(token, stripeObj)
            .then(billingToken => {
              let userObj = this.props.user;
              userObj.billingInfo = billingToken;
              updateUserCard(userObj);
              popup.hide()
           })} }
          fields= {metaDataMap} />
      </div>
    )
  }
}

export default View;